import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { currentSubscription, enablePush, pushSupported } from "@/lib/push";

// Optional nightly push at a chosen time (off by default)
export const BedtimeReminder = () => {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/bedtime/status", { params: { tz: Intl.DateTimeFormat().resolvedOptions().timeZone } }).then((x) => setR(x.data.reminder)).catch(() => {}); }, []);
  if (!r) return null;
  const save = async (next) => {
    const prev = r;
    setR(next);
    try {
      if (next.enabled && !(await currentSubscription())) {
        if (!pushSupported()) throw new Error("This browser can't show notifications. Try installing the app first.");
        if ((await enablePush()) !== "granted") throw new Error("Notifications are blocked. Allow them in your browser settings, then try again.");
      }
      await api.put("/bedtime/reminder", next);
      if (next.enabled !== prev.enabled) toast.success(next.enabled ? `We'll remind you at ${next.time}` : "Bedtime reminder off");
    } catch (e) { setR(prev); toast.error(e?.response ? errMsg(e) : e.message || "Couldn't turn on notifications"); }
  };
  return (
    <div className="flex flex-wrap items-center justify-center gap-3 text-sm opacity-90" data-testid="bedtime-reminder">
      <label className="inline-flex items-center gap-2 cursor-pointer">
        <input type="checkbox" checked={r.enabled} onChange={(e) => save({ ...r, enabled: e.target.checked })} className="w-4 h-4 accent-[#F3C98B]" data-testid="bedtime-reminder-toggle" />
        Remind me each night at
      </label>
      <input type="time" value={r.time} onChange={(e) => e.target.value && save({ ...r, time: e.target.value })} className="rounded-lg bg-white/10 border border-white/15 px-2 py-1 [color-scheme:dark]" data-testid="bedtime-reminder-time" />
    </div>
  );
};
